import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, HostBinding } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { DEBUG, SessionService } from '../session.service';
import { QRCodeWidget } from './qrcode.widget';
@Component({
  selector: 'app-booking-invite-page',
  standalone: true,
  imports: [CommonModule, QRCodeWidget, RouterLink],
  templateUrl: './booking.invite.landing.page.html',
})
export class BookingInviteLandingPage {
  _common = _common;
  @HostBinding('class') css = 'max-scroll';
  debug = DEBUG;
  code: string;
  subscription: Subscription;
  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
    public session: SessionService,
    private route: ActivatedRoute,
  ) {

    this.subscription = this.route.params.subscribe(params => {
      this.code = params['code'];
    });


  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  login() {
    let params = new URLSearchParams();
    params.append('url', `/${this.session.lang}/invite/${this.code}`);
    window.location.href = '/authorize?' + params.toString();
    // this.session.login();
  }
}
